import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Paper } from '@material-ui/core'
import { PieChart, Pie, Cell, Legend } from 'recharts'

const useStyles = makeStyles(() => ({
  pieChart: {
    margin: 'auto',
    width: 400,
    height: 400,
  },
}))

interface ChartData {
  totalUsers: number
  answer: string
}

interface ChartProps {
  data: ChartData[]
}

const COLORS = [
  '#5b71d7',
  '#00C49F',
  '#FFBB28',
  '#f08080',
  '#90ee90',
  '#d3d3d3',
  '#ffb6c1',
  '#ffa07a',
  '#20b2aa',
  '#87cefa',
]

function PieChartComponent({ data }: ChartProps) {
  const classes = useStyles()

  return (
    <Paper>
      <PieChart width={400} height={400} className={classes.pieChart}>
        <Legend layout="horizontal" verticalAlign="top" align="center" />
        <Pie
          data={data}
          dataKey="totalUsers"
          nameKey="answer"
          cx="50%"
          cy="50%"
          outerRadius={150}
          fill="#8884d8"
          label
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${entry.answer}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
      </PieChart>
    </Paper>
  )
}

export { PieChartComponent }
